import type { ButtonHTMLAttributes, ReactNode } from "react";
import { Spinner } from "./Spinner.js";

export type ButtonVariant = "primary" | "accent" | "secondary" | "ghost" | "danger";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: "sm" | "md";
  busy?: boolean;
  children: ReactNode;
}

export function Button({ variant = "secondary", size = "md", busy = false, disabled, className, children, type = "button", ...rest }: ButtonProps) {
  const classes = ["btn", `btn-${variant}`, `btn-${size}`, className ?? ""].join(" ").trim();
  return (
    <button type={type} className={classes} disabled={disabled === true || busy} aria-busy={busy} {...rest}>
      {busy ? <Spinner size={14} /> : null}
      {children}
    </button>
  );
}
